function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null,
/*#__PURE__*/
React.createElement("style", null, ".a{opacity:0.8;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null,
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(6.904)"
},
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 13.114)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M509.4,401.382H491.655a1.138,1.138,0,0,1-1.126-1.147v-1.311a.492.492,0,0,1,.256-.432L498,394.557a.492.492,0,0,1,.471.864l-6.957,3.795v1.019a.156.156,0,0,0,.142.164H509.4a.156.156,0,0,0,.142-.164v-1.02L502.6,395.42a.492.492,0,1,1,.471-.863l7.2,3.934a.491.491,0,0,1,.256.431v1.312A1.138,1.138,0,0,1,509.4,401.382Z",
  transform: "translate(-490.529 -394.497)"
})),
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(4.59)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M512.244,368.595a.492.492,0,0,1-.252-.914c2.338-1.4,2.373-5.167,2.373-5.2l0-3.7c-.348-1.932-2.575-3.279-4.39-3.295h-.034c-1.821,0-4.074,1.351-4.422,3.295l0,3.7c0,.036.036,3.706,2.4,5.21a.492.492,0,0,1-.529.829c-2.818-1.8-2.85-5.868-2.85-6.04l0-3.744a.467.467,0,0,1,.007-.08c.41-2.472,3.095-4.136,5.361-4.155h.038c2.274,0,4.986,1.67,5.4,4.155a.476.476,0,0,1,.007.081l0,3.743c0,.178-.032,4.366-2.852,6.049A.488.488,0,0,1,512.244,368.595Z",
  transform: "translate(-504.529 -354.497)"
}))),
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 13.114)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M474.88,401.384h0l-4.284,0a1.138,1.138,0,0,1-1.125-1.147v-1.311a.492.492,0,0,1,.256-.432l7.213-3.935a.492.492,0,0,1,.471.864l-6.956,3.8v1.019a.156.156,0,0,0,.142.164l4.284,0a.492.492,0,0,1,0,.984Z",
  transform: "translate(-469.471 -394.497)"
})),
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(4.59)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M486.585,368.595a.49.49,0,0,1-.264-.077c-2.818-1.8-2.85-5.868-2.85-6.04l0-3.744a.47.47,0,0,1,.007-.08c.41-2.472,3.095-4.136,5.361-4.155h.038a5.477,5.477,0,0,1,1.822.325.492.492,0,1,1-.327.927,4.515,4.515,0,0,0-1.461-.268h-.033c-1.822,0-4.074,1.351-4.422,3.295l0,3.7c0,.036.036,3.706,2.4,5.21a.492.492,0,0,1-.265.907Z",
  transform: "translate(-483.471 -354.497)"
})));

var SvgClients = function SvgClients(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 26.903,
      height: 20.001,
      viewBox: "0 0 26.903 20.001",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgClients, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/Clients.c79710df.svg";
export { ForwardRef as ReactComponent };